<template>
  <UModal v-model:open="isOpen" :ui="{ content: 'max-w-3xl' }">
    <template #content>
      <div class="p-6 sm:p-8 max-h-[85vh] overflow-y-auto">
        <WebuserFailedPointCodeReportPanel
          :active="isOpen"
          :client-id="clientId"
          :wu-id="wuId"
          :customer-name="customerName"
          :customer-email="customerEmail"
          :initial-report="initialReport"
          @success="emit('success')"
          @close="isOpen = false"
        />
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
interface Props {
  clientId: number
  wuId?: number
  customerName?: string
  customerEmail?: string
  initialReport?: {
    failedPointCode?: string
    failedPointCodeReason?: string
    adminNotes?: string
  }
}

const {
  wuId = 0,
  customerName = '',
  customerEmail = '',
} = defineProps<Props>()

const isOpen = defineModel<boolean>('open', { default: false })

const emit = defineEmits<{
  success: []
}>()
</script>
